import { combineReducers } from 'redux'
import { commissionCurrentDataReducer } from './data/commissionCurrentDataReducer'
import { commissionMembersReducer } from './members/commissionMembersReducer'
import { commissionPeoplesReducer } from './peoples/commissionPeoplesReducer'

export const currentReducer = combineReducers({
  data:    commissionCurrentDataReducer,
  members: commissionMembersReducer,
  peoples: commissionPeoplesReducer,
})
